import { Controller } from "@hotwired/stimulus"
import { PASTE_TAG } from "lexical"
import { marked } from "marked"

// Lexxy only auto-converts markdown when the clipboard is *only* text/plain.
// Many sources (VS Code, browsers, Notes) also put text/html on the clipboard,
// which skips markdown conversion. This fills that gap.
export default class extends Controller {
  connect () {
    this.boundPaste = this.onPaste.bind(this)
    this.editors().forEach((editor) => {
      editor.addEventListener("paste", this.boundPaste, true)
    })
  }

  disconnect () {
    this.editors().forEach((editor) => {
      editor.removeEventListener("paste", this.boundPaste, true)
    })
  }

  editors () {
    return this.element.querySelectorAll("lexxy-editor")
  }

  onPaste (event) {
    const editor = event.target.closest("lexxy-editor")
    if (!editor?.supportsMarkdown) return

    const clipboardData = event.clipboardData
    if (!clipboardData) return

    const text = clipboardData.getData("text/plain")?.trim()
    if (!text || !this.looksLikeMarkdown(text)) return

    const types = Array.from(clipboardData.types)
    if (types.length === 1 && types[0] === "text/plain") return

    event.preventDefault()
    event.stopImmediatePropagation()

    const html = marked.parse(text, { breaks: true })
    editor.contents?.insertHtml(html, { tag: PASTE_TAG })
  }

  looksLikeMarkdown (text) {
    return /^#{1,6}\s|^\*\s|^\d+\.\s|^\>\s|```|\*\*|__|^\|.+\|/m.test(text)
  }
}
